import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Tag from "../components/Tag";
import {
  getScrollAnimationVariants,
  defaultScrollViewportSettings,
} from "../hooks/useScrollAnimation";

import "./About.css";

// Import intro illustrations
import introIdea from "../assets/illustrations/intro-idea.png";
import introScale from "../assets/illustrations/intro-scale.jpeg";
import introUs from "../assets/illustrations/intro-us.png";

export default function About() {
  const { t } = useTranslation();
  const fadeInUp = getScrollAnimationVariants("fadeInUp");

  return (
    <motion.section
      id="about"
      initial="hidden"
      whileInView="visible"
      viewport={defaultScrollViewportSettings}
      variants={fadeInUp}
    >
      <div className="about-hero">
        <div className="about-hero-content">
          <div className="about-hero-text">
            <Tag>{t("about.whyUs")}</Tag>
            <h3>
              {t("about.title1")}
              <br />
              {t("about.title2")}
            </h3>
            <p>{t("about.subtitle")}</p>
          </div>
          <div className="about-hero-benefit">
            <h5>{t("about.saveCash")}</h5>
            <p className="text-s">{t("about.saveCashDesc")}</p>
          </div>
        </div>
        <img
          src={introIdea}
          alt="Design and idea illustration"
          className="img-container"
        />
      </div>

      <div className="about-features-grid">
        <div className="about-feature-card">
          <img
            src={introUs}
            alt="Start with idea illustration"
            className="img-container"
          />
          <h4>{t("about.startWithIdea")}</h4>
          <p>{t("about.startWithIdeaDesc")}</p>
        </div>
        <div className="about-feature-card">
          <h4>{t("about.speedUp")}</h4>
          <p>{t("about.speedUpDesc1")}</p>
          <p>{t("about.speedUpDesc2")}</p>
          <div className="about-feature-hint">
            <Tag>{t("about.easyStart")}</Tag>
            <p>{t("about.easyStartDesc")}</p>
          </div>
        </div>
      </div>

      <div className="about-hero about-hero-reverse">
        <img
          src={introScale}
          alt="Scale and growth illustration"
          className="img-container"
        />
        <div className="about-hero-content">
          <div className="about-hero-text">
            <Tag>{t("about.forSmallBusinesses")}</Tag>
            <h3>{t("about.testSmall")}</h3>
            <p>{t("about.testSmallDesc1")}</p>
            <p>{t("about.testSmallDesc2")}</p>
          </div>
          <div className="about-hero-benefit">
            <h5>{t("about.smartWay")}</h5>
            <p className="text-s">{t("about.smartWayDesc")}</p>
          </div>
        </div>
      </div>
    </motion.section>
  );
}
